import { render, staticRenderFns } from "./VehicleDetail.vue?vue&type=template&id=a8cd5772&"
import script from "./VehicleDetail.vue?vue&type=script&lang=js&"
export * from "./VehicleDetail.vue?vue&type=script&lang=js&"
import style0 from "./VehicleDetail.vue?vue&type=style&index=0&id=a8cd5772&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports